import React from 'react';
import classNames from 'classnames';
import { identity, isUndefined } from 'lodash/fp';
import Pagination from 'components/shared/pagination';
import PerPage from './PerPage';

const TablePagination = ({
  className,
  onPageChange,
  onPerPageChange,
  page,
  pageCount,
  perPage,
  perPageOptions,
  scrollTopOnChange,
}) => (
  <div className={classNames('Table-pagination', className)}>
    {pageCount > 1 && (
      <Pagination
        pages={pageCount}
        pageSelectCallback={onPageChange}
        selected={page}
        scrollTopOnChange={scrollTopOnChange}
      />
    )}
    {!isUndefined(perPage) && (
      <PerPage
        onChange={onPerPageChange}
        options={perPageOptions}
        value={perPage}
      />
    )}
  </div>
);

TablePagination.defaultProps = {
  onPageChange: identity,
  onPagePerChange: identity,
};

export default TablePagination;
